export default {
    serverURI: '',
    authDomain: process.env.VUE_APP_AUTH_DOMAIN || 'http://localhost:5100',
    // developerApiDomain: process.env.VUE_APP_DEVELOPER_API_DOMAIN || 'http://localhost:6700',
    developerApiDomainApi: 'http://localhost:8070/',
    developerApiDomain: process.env.VUE_APP_DEVELOPER_API_DOMAIN || 'http://uat-api.nuwarobotics.com',
    developerUploadApiDomain: process.env.VUE_APP_DEVELOPER_API_UPLOAD_DOMAIN || 'http://uat-file.nuwarobotics.com',
    fpsVersion: process.env.FPS_VERSION || 'v1/',
    fpsApiUpload: process.env.FPS_UPLOAD || 'upload',
    fpsAuth: process.env.FPS_AUTH || 'YWlydGFibGU6bnV3YTg4ODg=',
    developerApiVersion: process.env.DEVELOPER_API_VERSION || 'v1/',
    developerApiPrefix: process.env.DEVELOPER_API_PREFIX || 'developer/',
    developerAdminPrefix: process.env.DEVELOPER_ADMIN_PREFIX || 'admin/',
    developerUserPrefix: process.env.DEVELOPER_USER_PREFIX || 'user/',
    developerApiLoginPrefix: process.env.DEVELOPER_API_LOGIN_PREFIX || 'login/',
    developerApiLoginInfo: process.env.DEVELOPER_API_LOGININFO || 'info',
    developerApiVerify: process.env.DEVELOPER_API_VERFIY || 'verify',
    developerApiUser: process.env.DEVELOPER_API_USER || 'user',
    developerApiApp: process.env.DEVELOPER_API_USER || 'app',
    developerApiFile: process.env.DEVELOPER_API_FILE || 'list/',
    developerApiDownload: process.env.DEVELOPER_API_DOWNLOAD || 'download/',
    developerApiRegister: process.env.DEVELOPER_API_REGISTER || 'register',
    developerApiComplete: process.env.DEVELOPER_API_COMPLETE || 'complete',
    developerApiTicket: process.env.DEVELOPER_API_TICKET || 'ticket/',
    developerApiMail: process.env.DEVELOPER_API_MAIL || 'mail/',
    developerApiMessage: process.env.DEVELOPER_API_MESSAGE || 'message/',
    developerApiMotionFile: process.env.DEVELOPER_API_MOTIONFILE || 'motionFile/',
    developerApiUpload: process.env.DEVELOPER_API_UPLOAD || 'upload',
    developerApiResource: process.env.DEVELOPER_API_RESOURCE || 'developer/resource',
    developerApiMotionCategory: process.env.DEVELOPER_API_MOTION_CATEGORY || 'motionCategory',
    developerApiMotionTag: process.env.DEVELOPER_API_MOTION_TAG || 'motionTag'
}
